import React,{useEffect} from "react";
import { NavLink } from "react-router-dom";
import { useAappContext } from "../context/AppContext";
import shajit from "../assest/ShajIt.png";
import facebook_img from "../assest/icon_facebook.jpg";
import whatsapp_img from "../assest/icon_whatsapp.png";
    const Footer = ()=>{
    const {Avansis:avansis}= useAappContext();
    return (
        
        <>
        <section id="warp-footer" className="section section-p1 section-m1">
    <div className="content">
            
                {
                    avansis.map((avansis)=>{
                        // console.log(avansis);
                        const {id, name, address,email, mobaile,webLink}=avansis;
                        return  <div className="contact"  key={id}>
                                <p><span className="cname" >{name}</span></p>
                                <p><img width="20" height="20" src="https://img.icons8.com/windows/32/FFFFFF/place-marker.png" alt="place-marker"/> &nbsp;{address}&nbsp;<br/>
                                <img width="20" height="20" src="https://img.icons8.com/ios-glyphs/30/FFFFFF/phone--v1.png" alt="phone--v1"/>&nbsp; {mobaile} &nbsp;&nbsp;<br/>
                                <img width="20" height="20" src="https://img.icons8.com/material-outlined/50/FFFFFF/new-post.png" alt="new-post"/>&nbsp;{email} &nbsp; &nbsp;&nbsp;<img width="20" height="20" src="https://img.icons8.com/material-rounded/24/FFFFFF/internet.png" alt="internet"/>&nbsp; <NavLink to="https://www.avansisbd.com" target="_blank"> {webLink}</NavLink> 
                                </p>
                        
                                </div>
                    })
                }
            <div className="social-media" >
            <div className="follow-us">
                <h3 style={{fontSize:18}}>Follow us </h3>
                     <div className="social-icon">
                    <NavLink to="https://api.whatsapp.com/send?l=en&amp;phone=8801718964622" target="_blank">
                    <img src={whatsapp_img} title="WhatsApp" alt="WhatsApp" />
                    </NavLink>

                    <NavLink to="https://www.facebook.com/profile.php?id=61572997551862" target="_blank">
                    <img src={facebook_img} title="Facebook" alt="Facebook" />
                    </NavLink>
                </div>
            </div>
            <div className="desig-dev">
                <p>Developer Partner: 
                    <NavLink to="https://www.facebook.com/profile.php?id=61550497344613" target="_blank" style={{color:"whitesmoke"}}> Shaj It</NavLink>
                </p>
               
                    <div id="devcomp">
                        <div className="icon">
                        <NavLink to="https://www.facebook.com/profile.php?id=61550497344613" target="_blank">
                        <img height="70px" alt="IMG" title="IMG" src={shajit}/>
                        </NavLink>
                        </div>
                        <div className="info">
                        <NavLink to="https://api.whatsapp.com/send?l=en&amp; phone=8801818661698" target="_blank">Cell:01818-661698</NavLink>
                        </div>
                    </div>
               
            </div>
           

        </div>
    </div>
    {/* <div className="fotter-butom" style={{fontSize:14,color:"black"}}>
    Copyright © 2018<span style={{color:"black",marginLeft:5,fontSize:13}}>{avansis.map((avansisdata)=>{ return avansisdata.name})} </span>
    </div> */}
</section>

        </>
    );
}

export default Footer;